<template>
  <validation-provider v-slot="{ errors }" rules="" name="event.code">
    <v-autocomplete
      ref="code"
      dense
      v-model="selected"
      @focus="onFocus"
      @blur="onBlur"
      auto-select-first
      :items="codes"
      :item-text="codeAsString"
      :loading="isLoading"
      :label="$t('event.code')"
      :error-messages="errors"
      :search-input.sync="search"
      outlined
      no-filter
      hide-details="auto"
      return-object
    ></v-autocomplete>
  </validation-provider>
</template>

<script>
import EventService from '@/services/event.service'
import debounce from 'lodash/debounce'

export default {
  name: 'CodeCombo',

  created() {
    // create debounced fetch function for search watcher (300ms delay)
    this.debouncedFetch = debounce((category, searchValue) => {
      this.fetchCodes({ category, search: searchValue })
    }, 300)
  },

  beforeMount() {
    if (this.code) {
      this.codes.push(this.code)
    }
    this.selected = this.code
    if (this.category) {
      this.fetchCodes({ category: this.category })
    }
  },
  beforeDestroy() {
    if (this.debouncedFetch) {
      this.debouncedFetch.cancel()
    }
  },
  data: () => ({
    selected: null,
    isLoading: false,
    codes: [],
    search: null,
    hasFocus: false,
    wasAutoselected: false,
  }),
  props: {
    autocommit: {
      type: Boolean,
      default: false,
    },
    code: {
      type: Object,
      default: null,
    },
    category: {
      type: String,
      default: null,
    },
    minSearchLength: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    codeAsString: (item) => item.text,
    onFocus() {
      this.hasFocus = true
      if (this.wasAutoselected) {
        this.selected = null
        this.wasAutoselected = false
      }
    },
    onBlur() {
      this.hasFocus = false
      if (this.selected == null) {
        this.selected = this.codes[0]
        this.wasAutoselected = true
      }
    },
    fetchCodes(params) {
      this.isLoading = true
      EventService.fetchCodes(params)
        .then((res) => {
          this.codes = res.results || []
          if (this.codes.length > 0 && !this.selected && !this.hasFocus) {
            this.selected = this.codes[0]
            this.wasAutoselected = true
          }
        })
        .catch(() => {
          this.codes = []
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
  watch: {
    code(value) {
      if (value) {
        // keep selected code first in list, avoid duplicates
        this.codes = [value, ...this.codes.filter((c) => c !== value)]
      }
      this.selected = value
    },
    selected(value) {
      this.$emit('code-selected', value)
    },
    category(value) {
      // reset search and fetch codes limited to the category
      this.search = null
      if (value) {
        this.fetchCodes({ category: value })
      } else {
        this.codes = []
      }
    },
    search(value) {
      // if search is empty, fetch immediately (category-only or clear list)
      if (!value) {
        if (this.category) {
          this.fetchCodes({ category: this.category })
        } else {
          this.codes = []
        }
        return
      }

      if (value.trim().length < this.minSearchLength) {
        if (!this.category) {
          this.codes = []
        }
        return
      }

      // otherwise use debounced fetch (300ms)
      this.debouncedFetch(this.category, value)
    },
  },
}
</script>
